<template>
  <div
    id="pageSupportOptions"
    class="container"
    style="max-width: 900px !important"
  >
    <v-container grid-list-xl fluid class="mx-auto">
      <v-layout row wrap>
        <v-flex sm12>
          <h2>Suporte</h2>
        </v-flex>
        <v-flex
          v-for="(c, i) in loading ? [1, 2] : channels"
          :key="loading ? i : c.id"
        >
          <v-skeleton-loader
            :loading="loading"
            transition="scale-transition"
            height="434px"
            max-width="315"
            type="card, article"
          >
            <v-card class="rounded-xl card-support" @click="openChannel(c)">
              <v-img :src="c.image" height="250px"> </v-img>
              <v-card-title primary-title class="mx-auto">
                {{ c.title }}
              </v-card-title>
              <v-card-text>{{ c.description }}</v-card-text>
              <v-card-text>
                <v-layout row pa-2 style="display: flex; align-items: center">
                  <span class="pa-0">
                    <v-icon v-if="c.status == 'online'" color="green"
                      >circle</v-icon
                    >
                    <v-icon v-else color="red">circle</v-icon>
                  </span>
                  <span class="pl-2">{{ c.status }}</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    dark
                    color="primary px-5"
                    @click="openChannel(c)"
                  >
                    Iniciar
                  </v-btn>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-skeleton-loader>
        </v-flex>
      </v-layout>
    </v-container>
    <chat-dialog
      :opened="this.chatOpened"
      @onCloseChatDialog="onCloseChatDialog()"
    ></chat-dialog>
  </div>
</template>

<script>
import SupportService from "../../services/support.service";
import ChatDialog from "../../components/widgets/ChatDialog.vue";

export default {
  components: {
    ChatDialog,
  },
  metaInfo: {
    title: "LS",
    titleTemplate: "%s - Suporte",
    htmlAttrs: {
      lang: "pt-br",
      amp: false,
    },
  },
  data() {
    return {
      show: true,
      loading: true,
      chatOpened: false,
      channels: [{}],
    };
  },
  mounted() {
    this.loadChannels();
  },
  methods: {
    loadChannels() {
      SupportService.getSupportWhatsappLink()
        .then((response) => {
          console.log("canais: ", response.data);
          this.loading = false;
          this.channels = response.data.data;
          if (this.$route.query.channel === "gpt") {
            this.chatOpened = true;
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
    openChannel(channel) {
      console.log(channel);
      if (channel.type === "whatsapp") {
        this.openWhatsAppConversation(channel);
      } else {
        this.chatOpened = true;
      }
    },
    openWhatsAppConversation(channel) {
      const $url = `https://api.whatsapp.com/send?phone=${channel.number}&text=${channel.text}`;
      window.open($url, "_blank");
    },
    onCloseChatDialog() {
      this.chatOpened = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.card-support {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 315px;
  min-height: 434px;
}
.mt-45 {
  margin-top: -45px;
}
.mt-56 {
  margin-top: -56px;
}

.v-card__actions {
  a {
    text-decoration: none;
  }
}
</style>
